// api domain
// export const domain = 'http://localhost:4001'
export const domain = 'https://www.servisbizde.com/api'
export const domainSocket = 'https://www.servisbizde.com'